import Page from "webPage/Page";
import StickySection from "util/StickySection";

Page.register('single-case-studies', () => {
    new StickySection($('.js-sticky-section'), 960);
});